export function useLayoutWatchers() {
  const {initPusherWatcher} = usePusherNotifications();

  const initWatchers = () => {
    initPusherWatcher();
  };

  return {
    initWatchers,
  };
}
